export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: "首页", path: "/" },
    { label: "浪漫爱情", path: "/category/romance" },
    { label: "轻松喜剧", path: "/category/comedy" },
    { label: "情感剧情", path: "/category/drama" },
    { label: "经典重温", path: "/category/classic" },
    { label: "最新推荐", path: "/category/latest" },
  ];

  const aboutLinks = [
    { label: "关于我们", path: "/about" },
    { label: "品牌介绍", path: "/about#brand" },
    { label: "口碑评价", path: "/about#reputation" },
    { label: "联系我们", path: "/about#contact" },
  ];

  return (
    <footer className="bg-primary-500 text-primary-950">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-2xl text-primary-950"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-primary-950">
                  夫妻影院
                </span>
              </div>
              <p className="text-primary-800 text-sm leading-relaxed">
                夫妻影院致力于为夫妻情侣提供精选浪漫电影推荐，打造温馨二人世界观影体验。免费高清在线观看不缓冲，夫妻必看影视高清全集推荐。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-primary-950 mb-4">
                快速导航
              </h4>
              <ul className="space-y-2">
                {quickLinks.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-primary-800 text-sm hover:text-primary-950 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-primary-950 mb-4">
                关于
              </h4>
              <ul className="space-y-2">
                {aboutLinks.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-primary-800 text-sm hover:text-primary-950 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-primary-950 mb-4">
                联系我们
              </h4>
              <div className="space-y-2 text-primary-800 text-sm">
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line"></i>
                  </div>
                  <span>contact@fuqicinema.com</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-wechat-line"></i>
                  </div>
                  <span>微信公众号：夫妻影院</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <span>中国 · 北京</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-primary-400/40 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-primary-800 text-sm">
              &copy; {currentYear} 夫妻影院 版权所有 | 夫妻电影与情侣影院精选
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-primary-800 text-sm hover:text-primary-950 transition-colors" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-primary-800 text-sm hover:text-primary-950 transition-colors" rel="nofollow">
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}